/* global fetchUrl initialDate venueUrls sportUrls data headings minDate maxDate */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SummaryScheduleCalendarIndex from './SummaryScheduleCalendarIndex';
import SummaryScheduleTable from './SummaryScheduleTable';

export default function SummaryIndex(props) {
    const [selectedTab, setSelectedTab] = useState('summary');
    const [venues, setVenues] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [date, setDate] = useState(props.initialDate);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        axios
            .get(props.fetchUrl)
            .then((result) => {
                const { data } = result;
                setVenues(data.venues);
                setSchedules(data.schedules);
            })
            .catch((e) => {
                console.log(e.response);
            });
    };

    return (
        <div className="tw-flex tw-flex-col tw-h-full tw-gap-6 tw-pb-6">
            <div className="in-nav horizontal tw-justify-between" data-default-tab-id="summary-tab" role="tablist">
                <div className="tw-flex">
                    <button
                        className={`in-nav__item tw-mx-1 ${selectedTab === 'summary' ? 'active' : 'inactive'}`}
                        id="summary-tab"
                        data-tabs-target="#summary"
                        type="button"
                        role="tab"
                        onClick={() => setSelectedTab('summary')}
                    >
                        {$t('Summary')}
                    </button>
                    <button
                        className={`in-nav__item tw-mx-1 ${selectedTab === 'detailed' ? 'active' : 'inactive'}`}
                        id="detailed-tab"
                        data-tabs-target="#detailed"
                        type="button"
                        role="tab"
                        onClick={() => setSelectedTab('detailed')}
                    >
                        {$t('Detailed')}
                    </button>
                </div>
                <button type="submit" className="tw-h-8 tw-flex tw-items-center tw-px-5 tw-bg-blue tw-text-white tw-font-semibold tw-rounded-full">
                    {'Generate Report'}
                </button>
            </div>

            <div id="summary-schedule-tabs-content" className="tw-flex tw-flex-col tw-h-full tw-gap-y-3">
                {selectedTab === 'summary' && (
                    <div id="summary" role="tabpanel" aria-labelledby="summary-tab">
                        <SummaryScheduleTable data={props.data} headings={props.headings} venueUrls={props.venueUrls} sportUrls={props.sportUrls} />
                    </div>
                )}
                {selectedTab === 'detailed' && (
                    <div id="summary" role="tabpanel" aria-labelledby="summary-tab" className="styled-calendar fc fc-ltr fc-unthemed">
                        <SummaryScheduleCalendarIndex
                            fetchUrl={props.fetchUrl}
                            venues={venues}
                            schedules={schedules}
                            minDate={props.minDate}
                            maxDate={props.maxDate}
                            date={date}
                            setDate={setDate}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

if (document.getElementById('summarySchedulesIndex')) {
    var rootEl = document.getElementById('summarySchedulesIndex'); // data attributes below help us
    ReactDOM.render(
        <App>
            <SummaryIndex
                fetchUrl={fetchUrl}
                initialDate={initialDate}
                venueUrls={venueUrls}
                sportUrls={sportUrls}
                data={data}
                headings={headings}
                minDate={minDate}
                maxDate={maxDate}
            />
        </App>,
        rootEl,
    );
}
